var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadowIconEleven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4491_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 0H0V66H66V0Z",
    fill: "#D1AD6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0006 65.9989V36.2329L46.7286 16.9609L46.0686 17.8849L40.7226 26.0689L42.2406 27.2569L42.6366 27.9829L49.1706 30.8869V34.6489L48.3126 38.8729L49.1706 43.0969C49.1706 44.7469 48.3126 45.4069 48.3126 45.4069L47.5206 45.5389L40.5246 48.5089L37.6206 48.9049L35.6406 48.1129L30.2286 49.1029L25.8066 48.5749L17.6886 45.4069L17.2926 44.9449L17.2266 45.0109L38.2806 65.9989H66.0006Z",
    fill: "#BB8A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.999 18.7422C31.745 18.7422 30.755 19.5342 30.359 20.6562H19.799C19.271 20.6562 18.875 21.0522 18.875 21.5802C18.875 22.1082 19.271 22.5042 19.799 22.5042H30.359C30.755 23.6262 31.811 24.4182 32.999 24.4182C34.583 24.4182 35.837 23.1642 35.837 21.5802C35.837 20.0622 34.583 18.7422 32.999 18.7422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1172 37.755L38.4172 45.543L40.4632 37.293C38.6152 37.557 36.7012 37.689 35.1172 37.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4304 36.832C43.1664 36.898 42.8364 36.898 42.5724 36.964L39.7344 48.382L39.8004 48.58C43.6284 47.986 46.8624 46.93 48.3144 45.346L43.4304 36.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2812 36.3718L49.1093 43.0378V34.5898C48.1193 35.3818 46.7992 35.9098 45.2812 36.3718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9062 34.5898V43.0378L20.7342 36.3718C19.2162 35.9098 17.8962 35.3818 16.9062 34.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0766 37.7539C33.0106 37.7539 33.0106 37.7539 33.0766 37.7539C33.0106 37.7539 33.0106 37.7539 33.0106 37.7539L28.3906 48.5779L28.4566 48.9079C29.9746 49.0399 31.4926 49.1059 33.0766 49.1059C34.5946 49.1059 36.1786 49.0399 37.6966 48.9079L37.7626 48.5779L33.0766 37.7539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5076 37.0226C23.2436 36.9566 22.9136 36.9566 22.6496 36.8906L17.7656 45.4046C19.2176 46.9886 22.4516 48.0446 26.2796 48.6386L26.3456 48.4406L23.5076 37.0226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4844 37.3555L27.5964 45.5395L30.9624 37.7515C29.3124 37.6855 27.3984 37.5535 25.4844 37.3555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7996 17.098C46.4036 16.768 45.8096 16.834 45.4796 17.23L37.6256 26.8C37.3616 26.734 37.0976 26.668 36.7676 26.668C35.1836 26.668 33.9296 27.922 33.9296 29.506C33.9296 31.09 35.1836 32.344 36.7676 32.344C38.3516 32.344 39.6056 31.09 39.6056 29.506C39.6056 28.912 39.4076 28.384 39.1436 27.922L46.9316 18.418C47.2616 18.022 47.2616 17.428 46.7996 17.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1842 27.261L41.3262 28.317C41.4582 28.713 41.5243 29.109 41.5243 29.571C41.5243 32.145 39.4122 34.323 36.7722 34.323C34.1322 34.323 32.0202 32.211 32.0202 29.571C32.0202 28.383 32.4822 27.327 33.1423 26.535H33.0102C27.4662 26.535 16.9062 27.525 16.9062 31.287C16.9062 35.049 27.4662 36.039 33.0102 36.039C38.5542 36.039 49.1143 35.049 49.1143 31.287C49.1143 29.109 45.9463 27.921 42.1842 27.261Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4491_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowIconEleven);
export default __webpack_public_path__ + "static/media/shadow-icon-eleven.7e1b858ca2fc1e62ea2d91654ad1938a.svg";
export { ForwardRef as ReactComponent };